const paths = {
  root: '/',
  signin: 'signin',
  signup: 'signup',
  teachSignin: 'teach/signin',
  teachSignup: 'teach/signup',
  emailConfirmation: 'email/confirmation',
  emailVerification: 'fb447eb1/verify',
  resetPassword: 'fb447eb1/reset-password',
  forgotPassword: 'forgot-password',
  verifyEmail: 'email/verify',

  adminDashboard: 'a',
  adminTutors: 'a/tutors',
  applications: 'a/applications',
  interviewConfirmation: 'interview-confirmation',

  tutorOnboarding: 'tutor-onboarding',
  lessonQuestionnaire: 'lesson-questionnaire',
  classQuestionnaire: 'class-questionnaire',
  tutorDashboard: 't',
  tutork12: 't/k-12',
  tutorLesson: 't/k-12/lesson',
  tutorPrivateTuition: 't/private-tuition',
  tutorPerformance: 't/performance',
  tutorPayments: 't/payments',
  tutorTuitions: 't/tuitions',

  learnerDashboard: 's',
  studentTuitions: 's/tuitions',
  studentProfile: 'student/profile',
  studentCountry: 'student/country',
  studentTuition: 'student/tuition-selection',
  studentBookTuition: 'student/book-tuition',

  checkout: 'checkout',
  orderConfirmation: 'order-confirmation',
  paymentLink: 'payment-link',
  bankTranserConfirmation: 'bank-transfer-confirmation',

  whiteboard: 'whiteboard',
  waitingRoom: 'waiting-room',
  chatRoom: 'chat-room',
  chatMessaging: 'chat-messaging',
  chatWorkSheet: 'chat-worksheet',
};

export default paths;
